import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './NewUserLogin.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class NewUserLogin extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            token: undefined,
            passwords: {
                password: undefined,
                password2: undefined
            },
            user: {
                id: '',
                username: '',
                password: '',
                facebook_access_token: '',
                google_id_token: ''
            },
            facebook_access_token: '',
            google_id_token: '',
            isReadyToSubmit: false,
            message: {
                title: '',
                content: '',
                type: ''
            }
        };
    }

    sendToken = (e) => {
        this.setMessage('', '', 'loading');

        (async () => {
            try {
                console.log(this.state)
                const response = await send_token(this.state.token);
                console.log('Response: ', response);
                if (response.data.authenticated) {
                    this.props.userLogin(response.data);

                    this.setState({ user: response.data.user });

                    // If password method
                    if (this.state.facebook_access_token === '' && this.state.google_id_token === '') {
                        const responseUser = await updatePassword(this.state.passwords.password);
                        console.log('responseUser: ', responseUser);

                        if (responseUser.data.success) {
                            this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');
                            setTimeout(() => {
                                this.props.routeProps.history.push('/events');
                            }, 2000);
                        } else {
                            this.setMessage(window.general_strings.msg.oops, responseUser.data.error.msg, 'error');
                        }
                    } else {
                        const responseUserF = await updateSocial(this.state.facebook_access_token, this.state.google_id_token);
                        console.log('responseUserF: ', responseUserF);

                        if (responseUserF.data.success) {
                            this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');
                            setTimeout(() => {
                                this.props.routeProps.history.push('/events');
                            }, 2000);
                        } else {
                            this.setMessage(window.general_strings.msg.oops, responseUserF.data.error.msg, 'error');
                        }
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, response.data.reason, 'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function send_token(token) {
            return await ApiRequest(`/auth/login/token`, {
                method: 'POST',
                data: {
                    token: token
                }
            });
        }

        async function updatePassword(password) {
            return await ApiRequest(`/users/current`, {
                method: 'PUT',
                data: {
                    password
                }
            });
        }

        async function updateSocial(facebook_access_token, google_id_token) {
            return await ApiRequest(`/users/current`, {
                method: 'PUT',
                data: {
                    facebook_access_token: facebook_access_token,
                    google_id_token: google_id_token
                }
            });
        }

        if(e !== undefined){
            e.preventDefault();
        }
    }

    handleChange = (e) => {
        let passwords = {...this.state.passwords};
		let value = e.target.value;
        let name = e.target.attributes.getNamedItem('name').value;
        passwords[name] = value;
        this.setState({ passwords });
        let isReadyToSubmit = false;
        if(passwords['password'] === passwords['password2'] && this.state.token !== undefined){
            isReadyToSubmit = true;
            this.setState({ facebook_access_token: '' });
            this.setState({ google_id_token: '' });
        }
        this.setState({ isReadyToSubmit:isReadyToSubmit });
    }
	
    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    facebookCallback = (response) => {
        this.setState({ facebook_access_token: response.accessToken });
        this.setState({ google_id_token:'' }, (e) => this.sendToken(e, 'facebook'));
    }

    googleCallback = (response) => {
        this.setState({ google_id_token: response.tokenId });
        console.log('google response: ', response);
        this.setState({ facebook_access_token:'' }, (e) => this.sendToken(e, 'google'));
        this.googleButtonOpacityToggle();
    }

    googleButtonOpacityToggle = () => {
        let googleButtonFaded = this.state.googleButtonFaded;
        googleButtonFaded = !googleButtonFaded;
        this.setState({ googleButtonFaded });
    }
    
    componentDidMount() {
        if(this.props.routeProps.location.search){
            this.setState({ token: this.props.routeProps.location.search.split('=')[1] });
        } else {
            this.setMessage(window.general_strings.msg.oops, 'Your token is invalid', 'error');
            this.setState({ isReadyToSubmit:false });
        }
    }
	
    render() {
		return (
            <form onSubmit={this.sendToken}>
			    <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <Message
                                message={this.state.message}
                            />
                            <p className="showtix-subtitle">{strings.content}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="password">{strings.password}</label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input"
                                        type="password"
                                        object="user"
                                        id="password"
                                        name="password"
                                        value={this.state.passwords.password || ''}
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.handleChange}
                                        onBlur={this.validateRequiredField}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="password2">{strings.confirmPassword}</label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input"
                                        type="password"
                                        object="user"
                                        id="password2"
                                        name="password2"
                                        value={this.state.passwords.password2 || ''}
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.handleChange}
                                        onBlur={this.validateRequiredField}
                                        required
                                    />
                                </div>
                                {!this.state.isReadyToSubmit 
                                    && this.state.passwords.password2 && this.state.passwords.password2 !== '' 
                                        &&
                                            <div className="showtix-note error">
                                                {strings.passwordsNotTheSame}
                                            </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <button
                                type="submit"
                                className="showtix-button showtix-background__primary-2"
                                onClick={this.sendToken}
                                disabled={this.state.isReadyToSubmit ? "": "disabled"}
                            >
                                <span>{strings.submit}</span>
                            </button>
                        </div>
                    </div>
                </div>
            
                <div className="showtix-section showtix-background__primary-1">       
                    <div className="container"> 
                        <div className="row">
                            <div className="col-12">
                                <h1>{strings.useSocial}</h1>
                                <FacebookLogin
                                    appId= {process.env.REACT_APP_FACEBOOK_APP_ID}
                                    autoLoad={false}
                                    fields="name,email"
                                    callback={this.facebookCallback}
                                    cssClass="facebook-login-button"
                                    icon="fa-facebook"
                                />
                                <GoogleLogin
                                    clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                    buttonText="Login"
                                    onRequest={this.googleButtonOpacityToggle}
                                    onSuccess={this.googleCallback}
                                    onFailure={this.googleButtonOpacityToggle}
                                    className={this.googleButtonFaded ? 'google-login-button faded' : 'google-login-button'}
                                >      
                                    <span>
                                        <i className="fa fa-google"></i>
                                        {strings.loginGoogle}
                                    </span>
                                </GoogleLogin>
                            </div>
                        </div>
                    </div>
                </div>        
            </form>    
		);
  	}
}

export default NewUserLogin;



// WEBPACK FOOTER //
// ./src/components/NewUserLogin/NewUserLogin.js